import {
  equalSizes as buttonEqualSizes,
  iconSizes as buttonIconSizes,
} from "../Buttons/baseVariants";

export const equalSizes = {
  ...buttonEqualSizes,
  xl: "h-20 w-20",
};

export const iconSizes = {
  ...buttonIconSizes,
  xl: 40,
};

export const avatarStatus = {
  none: "",
  active: "bg-green-400",
  "in-active": "bg-orange",
  disabled: "bg-gray-400",
  deceased: "bg-gray-400",
};
